module.exports = __webpack_public_path__ + "img/cleaner.69be22a3.svg";